import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { TagCategoryItem } from '@/entities/tags/domain';

export type TagCategoryResponse = {
  data: TagCategoryItem[];
  paging: {
    after: string;
    limit: number;
  };
};

type GetTagCategoriesParams = {
  limit?: number;
  after?: string;
};

export const getTagCategoriesApi = async ({ limit = 1000, after = '' }: GetTagCategoriesParams = {}) => {
  const { data } = await openMetadataApiClient.get<TagCategoryResponse>('/classifications', {
    params: {
      limit,
      ...(after ? { after } : {}),
      fields: 'termCount,owners,domains',
    },
  });
  return data;
};
